var _g, _defs;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#480a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6 2.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m2 7.063c0 .312-1.79.937-4 .937s-4-.625-4-.937C0 7.374 1.79 5.5 4 5.5s4 1.875 4 4.063m2.75-1.635a1.75 1.75 0 1 0-1.25-.096V10.5l.75.75.5-.5.5-.5-.5-.5.75-.75-.75-.75zM11 6.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "480a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
});
const SvgPasskeysFilledsmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPasskeysFilledsmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzI3MV8yMzk5KSI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNiAyLjVDNiAzLjYwNDU3IDUuMTA0NTcgNC41IDQgNC41QzIuODk1NDMgNC41IDIgMy42MDQ1NyAyIDIuNUMyIDEuMzk1NDMgMi44OTU0MyAwLjUgNCAwLjVDNS4xMDQ1NyAwLjUgNiAxLjM5NTQzIDYgMi41Wk04IDkuNTYyNUM4IDkuODc1IDYuMjA5MTQgMTAuNSA0IDEwLjVDMS43OTA4NiAxMC41IDAgOS44NzUgMCA5LjU2MjVDMCA3LjM3NSAxLjc5MDg2IDUuNSA0IDUuNUM2LjIwOTE0IDUuNSA4IDcuMzc1IDggOS41NjI1Wk0xMC43NSA3LjkyNzUzQzExLjQ3MjkgNy43MTIzOSAxMiA3LjA0Mjc2IDEyIDYuMjVDMTIgNS4yODM1IDExLjIxNjUgNC41IDEwLjI1IDQuNUM5LjI4MzUgNC41IDguNSA1LjI4MzUgOC41IDYuMjVDOC41IDYuOTQ4MSA4LjkwODc2IDcuNTUwNzMgOS41IDcuODMxNTlWMTAuNUwxMC4yNSAxMS4yNUwxMC43NSAxMC43NUwxMS4yNSAxMC4yNUwxMC43NSA5Ljc1TDExLjUgOUwxMC43NSA4LjI1VjcuOTI3NTNaTTExIDYuMjVDMTEgNi42NjQyMSAxMC42NjQyIDcgMTAuMjUgN0M5LjgzNTc5IDcgOS41IDYuNjY0MjEgOS41IDYuMjVDOS41IDUuODM1NzkgOS44MzU3OSA1LjUgMTAuMjUgNS41QzEwLjY2NDIgNS41IDExIDUuODM1NzkgMTEgNi4yNVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzI3MV8yMzk5Ij4KPHJlY3Qgd2lkdGg9IjEyIiBoZWlnaHQ9IjEyIiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";